import { render, staticRenderFns } from "./JobDescriptionCreate.vue?vue&type=template&id=2e0c5783"
import script from "./JobDescriptionCreate.vue?vue&type=script&lang=js"
export * from "./JobDescriptionCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports